import { render } from "./LedgerTable.vue?vue&type=template&id=fcecabf0&scoped=true"
import script from "./LedgerTable.vue?vue&type=script&lang=js"
export * from "./LedgerTable.vue?vue&type=script&lang=js"

import "./LedgerTable.vue?vue&type=style&index=0&id=fcecabf0&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcecabf0"]])

export default __exports__